export enum HOLIDAY_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum HOLIDAY_REFERENCE_SECTION {
  HOLIDAY = 'Holiday',
  LEAVES = 'Leaves',
}

export enum HOLIDAY_REFERENCE_CATEGORIES {
  CATEGORIES = 'Leave Category',
  DAYS = 'Days',
  RELIGION = 'Religion',
  EMPLOYEE_TYPES = 'Employee_Types',
  LEAVES_TYPE = 'Leave Type',
}
export enum HOLIDAY_CATEGORY_REFERENCE_CATEGORY_FIELD {
  LEAVES_DURATION = 'Leave Durations',
  EMPLOYEE_TYPES = 'Employee_Types',
  LEAVES_TYPE = 'Leave Type',
}
